import React, { useState } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { AddIcon } from 'components/Icons';
import { ELEMENT_MENU } from 'constants/element-menu';
import ElementPickerMenuItem from './ElementPickerMenuItem';

import './FloatingMenu.scss';

const FLATTENED_ELEMENT_MENU = ELEMENT_MENU.flatMap(({ elements }) => elements).filter(
  ({ type }) => !['text', 'blockquote', 'attachment', 'variable'].includes(type)
);

function FloatingMenu({ top, handleToolbarElements, isWix }) {
  const [visible, setVisible] = useState(false);

  const elements = isWix
    ? FLATTENED_ELEMENT_MENU.filter((f) => isWix && !['price', 'miles'].includes(f.type))
    : FLATTENED_ELEMENT_MENU;

  const menu = () => (
    <Menu>
      {elements.map((option, i) => (
        <ElementPickerMenuItem
          key={`fcd-item-${i}`}
          id={`fcd-item-${i}`}
          handleToolbarElements={handleToolbarElements}
          setVisible={setVisible}
          {...option}
        />
      ))}
    </Menu>
  );

  return (
    <div className="floating-menu" style={{ top: top }}>
      <Dropdown
        overlay={menu}
        visible={visible}
        onVisibleChange={(value) => setVisible(value)}
        trigger={['click']}
        placement="bottomRight"
        overlayClassName="floating-menu-dropdown"
        className="rich-editor-list">
        <Button className="medium-btn primary-btn plus-btn" onMouseDown={(e) => e.preventDefault()}>
          <AddIcon />
        </Button>
      </Dropdown>
    </div>
  );
}

export default FloatingMenu;
